import { events } from '../config/events'

export type AnalyticsEvent = (typeof events)[keyof typeof events]

export function getEventByAnalyticsId(
  analyticsId: string,
): AnalyticsEvent | undefined {
  return events[analyticsId as keyof typeof events]
}
